/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import { Storage } from '../storage/Storage';

export class Settings {
    TAG: string = 'Settings';

    private mIsVideoWindowEnabled: boolean;

    private mLastTunedChannelNumber: string | null;

    constructor() {
        this.mIsVideoWindowEnabled = true;
        this.mLastTunedChannelNumber = null;
        this.readSavedSettings();
    }

    private readSavedSettings(): void {
        this.mIsVideoWindowEnabled =
            Storage.getInstance().getItem(Storage.Keys.IS_VIDEO_WINDOW_ENABLED) ?? true;
        this.mLastTunedChannelNumber = Storage.getInstance().getItem(
            Storage.Keys.LAST_TUNED_CHANNEL,
        );
    }

    public getLastTunedChannelNumber(): string | null {
        return this.mLastTunedChannelNumber;
    }

    public isVideoWindowEnabled(): boolean {
        return this.mIsVideoWindowEnabled;
    }

    public setIsVideoWindowEnabled(value: boolean): void {
        this.mIsVideoWindowEnabled = value;
        Storage.getInstance().setItem(Storage.Keys.IS_VIDEO_WINDOW_ENABLED, value);
    }

    public setLastTunedChannelNumber(channelNumber: string): void {
        this.mLastTunedChannelNumber = channelNumber;
        Storage.getInstance().setItem(Storage.Keys.LAST_TUNED_CHANNEL, channelNumber);
    }

    public toJson(): Object {
        return {
            lastTunedChannelNumber: this.mLastTunedChannelNumber,
            isVideoWindowEnabled: this.mIsVideoWindowEnabled,
        };
    }
}
